import { useAuth } from "../lib/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "./common/Button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "./common/Card";
import useBrandTranslation from "../hooks/useBrandTranslation";

export default function ProfessionalAccessGate({ children }) {
  const { t } = useBrandTranslation();
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const blocked =
    user?.role === "doctor" && user?.is_professional_enabled === false;

  if (!blocked) return children;

  const allowedWhilePending = ["/", "/home", "/logout", "logout", "/profile"];

  if (allowedWhilePending.includes(location.pathname)) {
    return children;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-xl text-red-700">
            {t("app.gate.title", "Validación pendiente")}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-gray-700 text-sm">
            {t(
              "app.gate.body",
              "Tu cuenta profesional aún no está habilitada para operar. Completá tus datos en Settings y subí fotos del DNI frente y dorso para que administración pueda validarte."
            )}
          </p>
          <Button className="w-full" onClick={() => navigate("/profile")}>
            {t("app.gate.goSettings", "Ir a Settings")}
          </Button>
          <Button variant="outline" className="w-full" onClick={() => navigate("/")}>
            {t("app.gate.goHome", "Ir al menú principal")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
